// src/blocks/icon/SVGs/burger.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var BurgerSVG = ({
  title = "Burger Icon",
  desc = "Burger Icon",
  descId,
  width = 16,
  height = 16,
  ...props
}) => {
  const titleId = React.useId();
  const decriptionId = React.useId();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-labelledby": titleId,
      "aria-describedby": decriptionId,
      ...props,
      children: [
        desc ? /* @__PURE__ */ jsx("desc", { id: decriptionId, children: desc }) : null,
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx("path", { d: "M2 8H14", stroke: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M2 12H14", stroke: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M2 4H14", stroke: "currentColor" })
      ]
    }
  );
};
var burger_default = BurgerSVG;

export {
  burger_default
};
